export default __webpack_public_path__ + "static/nissan_white-fe6997a7388a98a1fc319dadcf8ea5eb.jpg";